import { createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import { reducers } from "reducers/index";
import { composeWithDevTools } from "redux-devtools-extension/developmentOnly";
import { createTracker } from "redux-segment";

const tracker = createTracker();

export const store = createStore(
  reducers,
  composeWithDevTools(applyMiddleware(thunk, tracker))
);



// WEBPACK FOOTER //
// ./src/js/store.js